/**
 * Application configuration management
 */

const config = {
  // API Configuration
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',

  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',

  // Feature flags
  FEATURES: {
    ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    PWA: process.env.REACT_APP_ENABLE_PWA === 'true',
    OFFLINE_MODE: process.env.REACT_APP_ENABLE_OFFLINE === 'true',
    PUSH_NOTIFICATIONS: process.env.REACT_APP_ENABLE_PUSH === 'true',
  },

  // UI Configuration
  UI: {
    ITEMS_PER_PAGE: 12,
    MAX_CART_ITEMS: 99,
    IMAGE_LAZY_LOADING: true,
    ANIMATION_DURATION: 300,
  },

  // Validation Rules
  VALIDATION: {
    PASSWORD_MIN_LENGTH: 8,
    USERNAME_MIN_LENGTH: 3,
    USERNAME_MAX_LENGTH: 20,
    NAME_MAX_LENGTH: 50,
    EMAIL_MAX_LENGTH: 254,
    PHONE_PATTERN: /^\+?1?-?\.?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/,
    PASSWORD_PATTERN: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  },

  // File Upload
  UPLOAD: {
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
    ALLOWED_EXTENSIONS: ['jpg', 'jpeg', 'png', 'webp'],
  },

  // Cache Configuration
  CACHE: {
    PRODUCTS_TTL: 5 * 60 * 1000, // 5 minutes
    USER_DATA_TTL: 10 * 60 * 1000, // 10 minutes
    CART_STORAGE_KEY: 'amfashion_cart',
    USER_PREFERENCES_KEY: 'amfashion_preferences',
  },

  // Error Messages
  ERRORS: {
    NETWORK: 'Network error. Please check your connection and try again.',
    UNAUTHORIZED: 'Please log in to continue.',
    FORBIDDEN: 'You do not have permission to perform this action.',
    NOT_FOUND: 'The requested resource was not found.',
    SERVER_ERROR: 'Something went wrong. Please try again later.',
    VALIDATION: 'Please check your input and try again.',
  },
};

// Validate configuration
const validateConfig = () => {
  const errors = [];

  // Check required environment variables in production
  if (config.NODE_ENV === 'production') {
    if (!process.env.REACT_APP_API_URL) {
      errors.push('REACT_APP_API_URL is required in production');
    }
  }

  // Validate API URL format
  try {
    new URL(config.API_URL);
  } catch (e) {
    errors.push('Invalid API_URL format');
  }

  if (errors.length > 0) {
    // Import logger dynamically to avoid circular dependency
    import('../services/logger').then(({ default: logger }) => {
      logger.error('Configuration validation errors', null, { errors });
    });

    if (config.NODE_ENV === 'production') {
      throw new Error(`Configuration validation failed: ${errors.join(', ')}`);
    }
  }
};

// Validate configuration on load
validateConfig();

export default config;
